import { Injectable } from '@angular/core';
import { fuseConfig, whitelabelBlueBerry } from '@configs/fuse-config';
import { find } from 'lodash';
import { FuseConfigService } from '@shared/@fuse/services/config.service';
import { environment } from '@environments/environment';
import { CompanyGroup } from '@shared/models/company-group';

interface ThemeWhiteLabel {
    id: string;
    title: string;
    logo: string;
    value: string;
    themeId: string;
}
const eighCapTheme: ThemeWhiteLabel = {
    id: 'Eightcap',
    title: 'Eightcap',
    logo: 'eightcap',
    value: 'theme-default',
    themeId: 'eig'
};

const bluTheme: ThemeWhiteLabel = {
    id: 'BlueBerry',
    title: 'BlueBerry',
    logo: 'blueberry',
    value: 'theme-blueberry',
    themeId: 'blu'
};
const themeWhitelabels: ThemeWhiteLabel[] = [eighCapTheme, bluTheme];

const CURRENT_THEME_ID = 'CURRENT_THEME_ID';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    constructor(private _fuseConfigService: FuseConfigService) {}

    get currentTheme() {
        const currentThemeId = localStorage.getItem(CURRENT_THEME_ID);
        let currentTheme: ThemeWhiteLabel;
        if (currentThemeId) {
            currentTheme = find(themeWhitelabels, (item) => item.themeId == currentThemeId);
        } else {
            currentTheme = find(themeWhitelabels);
        }
        return currentTheme;
    }

    get whiteLables() {
        return themeWhitelabels;
    }

    setWhitelabel(whitelabel: ThemeWhiteLabel): void {
        const color = whitelabel['value'];
        if (color === 'theme-blueberry') {
            this._fuseConfigService.config = whitelabelBlueBerry;
        } else {
            this._fuseConfigService.config = fuseConfig;
        }
        localStorage.setItem(CURRENT_THEME_ID, whitelabel.themeId);
    }

    loadDefaultTheme() {
        const companyGroup = environment.loginGroup || CompanyGroup.EIG;
        if (companyGroup === CompanyGroup.BLU) {
            this.setWhitelabel(bluTheme);
        } else {
            this.setWhitelabel(eighCapTheme);
        }
    }

}
